<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">forum</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">{{ data.titulo }}</h2>
    <span class="modal-subtitle">{{ data.nomeCliente }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fechar()"
      matTooltip="Fechar" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (isLoading) {
    <app-loading-box-default-list></app-loading-box-default-list>
  } @else if (!possuiPermissao) {
    <app-empty-state icon="lock" title="Sem permissão para visualizar CRM"
      subtitle="Solicite ao administrador a permissão Visualizar do CRM.">
    </app-empty-state>
  } @else if (oportunidades.length === 0) {
    <app-empty-state icon="forum" title="Nenhuma oportunidade no CRM"
      subtitle='Este cliente ainda não tem oportunidades no CRM. Use "Incluir oportunidade no CRM" para criar a primeira.'>
    </app-empty-state>
  } @else {
    <div class="desktop-view">
      <div class="table-container">
        <table mat-table [dataSource]="oportunidadesExibidas" matSort [matSortActive]="colunaOrdenacao ?? ''"
          [matSortDirection]="colunaOrdenacao ? direcaoOrdenacao : ''" (matSortChange)="atualizarOrdenacao($event)" class="w-100">
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
            <td mat-cell *matCellDef="let oportunidade">
              <button type="button" class="btn-link p-0 border-0 bg-transparent text-bold text-nowrap"
                [attr.aria-label]="'Abrir oportunidade #' + oportunidade.codigo + ' no CRM'" (click)="abrirNoCrm(oportunidade)">
                #{{ oportunidade.codigo }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="titulo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Oportunidade</th>
            <td mat-cell *matCellDef="let oportunidade">
              <div class="d-flex flex-column">
                <span class="oportunidades-cliente-titulo">{{ oportunidade.titulo }}</span>
                <small class="text-muted">Criado em {{ oportunidade.datetimeInclusao | date:'dd/MM/yyyy' }}</small>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="etapa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Etapa</th>
            <td mat-cell *matCellDef="let oportunidade">
              <ng-container *ngTemplateOutlet="tplEtapa; context: { $implicit: oportunidade }"></ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="vendedor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendedor</th>
            <td mat-cell *matCellDef="let oportunidade">{{ oportunidade.nomeVendedor }}</td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Valor</th>
            <td mat-cell *matCellDef="let oportunidade" class="text-end">
              <ng-container *ngTemplateOutlet="tplValor; context: { $implicit: oportunidade }"></ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="proximaAcao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Próxima ação</th>
            <td mat-cell *matCellDef="let oportunidade">
              <ng-container *ngTemplateOutlet="tplProximaAcao; context: { $implicit: oportunidade }"></ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="colunasExibidas"></tr>
          <tr mat-row *matRowDef="let row; columns: colunasExibidas"></tr>
        </table>
      </div>
    </div>

    <div class="mobile-view">
      @for (oportunidade of oportunidadesExibidas; track oportunidade.idOportunidade) {
        <div class="card-mobile mb-3">
          <div class="card-header-mobile d-flex justify-content-between align-items-center gap-2">
            <button type="button" class="btn-link p-0 border-0 bg-transparent text-bold text-nowrap"
              [attr.aria-label]="'Abrir oportunidade #' + oportunidade.codigo + ' no CRM'" (click)="abrirNoCrm(oportunidade)">
              #{{ oportunidade.codigo }}
            </button>
          </div>
          <div class="card-body-mobile p-3">
            <div class="mb-2"><strong>Oportunidade:</strong> {{ oportunidade.titulo }}</div>
            <div class="mb-2"><strong>Criado em:</strong> {{ oportunidade.datetimeInclusao | date:'dd/MM/yyyy' }}</div>
            <div class="mb-2">
              <strong>Etapa:</strong>
              <ng-container *ngTemplateOutlet="tplEtapa; context: { $implicit: oportunidade }"></ng-container>
            </div>
            <div class="mb-2"><strong>Vendedor:</strong> {{ oportunidade.nomeVendedor }}</div>
            <div class="mb-2">
              <strong>Valor:</strong> <ng-container *ngTemplateOutlet="tplValor; context: { $implicit: oportunidade }"></ng-container>
            </div>
            <div>
              <strong>Próxima ação:</strong>
              <ng-container *ngTemplateOutlet="tplProximaAcao; context: { $implicit: oportunidade }"></ng-container>
            </div>
          </div>
        </div>
      }
    </div>

    @if (oportunidades.length === 10) {
      <small class="d-block text-muted mt-2">São exibidos apenas os 10 últimos registros.</small>
    }
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-button type="button" class="btn-link me-auto" (click)="verTodosNoCrm()">
    <mat-icon class="material-symbols-outlined">view_kanban</mat-icon>
    Ver todos no CRM
  </button>
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
  <button mat-flat-button type="button" class="btn-primary" (click)="incluirNoCrm()">
    <mat-icon class="material-symbols-outlined">add</mat-icon>
    Incluir oportunidade no CRM
  </button>
</mat-dialog-actions>

<ng-template #tplEtapa let-oportunidade>
  <div class="oportunidades-cliente-etapa">
    <!-- Mesmo badge da coluna "Etapa atual" da visão Lista do CRM, com os mesmos padrões de cor e ícone. -->
    <span class="oportunidades-cliente-etapa-badge"
      [style.color]="oportunidade.corEtapaExibida"
      [style.background]="oportunidade.corEtapaExibida + '22'"
      [style.border-color]="oportunidade.corEtapaExibida + '33'">
      <mat-icon class="material-symbols-outlined">{{ oportunidade.iconeEtapa || 'description' }}</mat-icon>
      {{ oportunidade.nomeEtapa }}
    </span>
    @if (oportunidade.descricaoResultado) {
      <!-- Neutro: as opções de Resultado são configuradas pela empresa, sem um "Ganho" fixo. -->
      <span class="status-badge badge-cinza">
        {{ oportunidade.descricaoResultado }}
      </span>
    }
    @if (oportunidade.isArquivado) {
      <span class="status-badge badge-cinza">Arquivado</span>
    }
  </div>
</ng-template>

<ng-template #tplValor let-oportunidade>
  @if (oportunidade.valor !== null && oportunidade.valor !== undefined) {
    <div class="d-flex flex-column align-items-end">
      <span>{{ oportunidade.valor | abnt:'preco':2 }}</span>
      <small class="text-muted">{{ oportunidade.origemValor }}</small>
    </div>
  } @else {
    <span class="text-muted">—</span>
  }
</ng-template>

<ng-template #tplProximaAcao let-oportunidade>
  @if (oportunidade.proximaAcao) {
    <div class="d-flex flex-column">
      <span>{{ oportunidade.proximaAcao.descricao }}</span>
      @if (oportunidade.proximaAcao.dataPrevista) {
        @if (oportunidade.isAcaoVencida) {
          <span class="status-badge badge-vermelho align-self-start">
            <mat-icon class="material-symbols-outlined">error</mat-icon>
            Vencida em {{ oportunidade.proximaAcao.dataPrevista | date:'dd/MM/yyyy' }}
          </span>
        } @else {
          <small class="text-muted">{{ oportunidade.proximaAcao.dataPrevista | date:'dd/MM/yyyy' }}</small>
        }
      }
    </div>
  } @else {
    <span class="text-muted">—</span>
  }
</ng-template>
